import { Component, OnInit} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { GeneralService } from '../../../services/general.service';
import { GroupService } from '../../../services/group.service';
import {ModalConfirmComponent} from '../../../modal-confirm/modal-confirm.component';
import {CompanyComponent} from '../company/company.component';

@Component({
  selector: 'app-companies',
  templateUrl: './companies.component.html',
  styleUrls: ['./companies.component.scss']
})
export class CompaniesComponent implements OnInit {
  userId: any;
  userToken: any;
  listCompanies = [];
  temp = [];
  load = true;

  constructor(private toastr: ToastrService, public dialog: MatDialog, private gralService: GeneralService, private groupService: GroupService) {
    this.userToken =  localStorage.getItem('G13xTfsdf234TVsd23513ffdgFdf2352');
    gralService.changeTextHead('COMPANIES');
    this.getCompanies();
  }

  ngOnInit() {
  }



  getCompanies(){
    this.groupService.getCompanies(this.userToken).then((data) => {
      if(data['EsValido']){
        this.listCompanies = data['Entidades'];
        this.temp = data['Entidades'];
      }else{
        this.toastr.error(data['MensajeUsuario'], 'Error al editar');
        return;
      }
      this.load = false;
    }, (err) => {
      console.log(err);
      this.load = false;
      this.listCompanies = null;
      if(err.status == 401){
        this.gralService.actDeacUser(false);
      }
    });
  }

  updateFilter(event) {
    const val = event.target.value;
    // filter our data
    const temp = this.temp.filter(function(d) {
      let ret = d.RFC.indexOf(val) !== -1 || !val;
      ret = ret+d.RazonSocial.indexOf(val) !== -1 || !val;
      return ret;
    });
    // update the rows
    this.listCompanies = temp;
  }

  add(){
    const dialogRef = this.dialog.open(CompanyComponent, {
      minWidth: '50%',
      position: {
        top: '6%'
      },
      data: { type: 'add', userId: this.userId, userToken: this.userToken }
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        if(this.listCompanies){
          this.listCompanies.push(result['data']);
        }else{
          this.getCompanies();
        }
      }
    });
  }

  edit(id, idx){
    this.groupService.getCompany(id, this.userToken).then((data) => {
      const dialogRef = this.dialog.open(CompanyComponent, {
        minWidth: '50%',
        position: {
          top: '6%'
        },
        data: { type: 'edit', id: id, info: data['entidad'], userId: this.userId, userToken: this.userToken }
      });

      dialogRef.afterClosed().subscribe(result => {
        if(result){
          this.toastr.success('Empresa actualizada', 'Editar empresa');
          this.listCompanies[idx] = result['data'];
        }
      });
    }, (err) => {
      console.log(err);
      this.toastr.error(err['error'].msg, 'Editar empresa');
      if(err.status == 401){
        this.gralService.actDeacUser(false);
      }
    });
  }


  changeStatus(id, status, idx){
    let dataa = {};
    if(status == 'inactive'){
      dataa = { type: 'delete', id: id, button: 'Desactivar', title: 'Desactivar empresa', content: '¿Esta seguro de deactivar esta empresa?', icon: 'warning' };
    }else{
      dataa = { type: 'active', id: id, button: 'Activar', title: 'Activar empresa', content: '¿Esta seguro de activar esta empresa?', icon: 'warning' };
    }


    const dialogRef = this.dialog.open(ModalConfirmComponent, {
      minWidth: '50%',
      position: {
        top: '6%'
      },
      data: dataa
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        const params = {status: status};
        this.groupService.statusCompany(id, params, this.userId, this.userToken).then(data => {
          this.listCompanies[idx].status = status;
          this.toastr.success('Se cambio el estatus de la empresa', 'Cambiar estatus');
        }, (err) => {
          console.log(err);
          this.toastr.error('Error al cambiar estatus de la empresa', 'Cambiar estatus');
          if(err.status == 401){
            this.gralService.actDeacUser(false);
          }
        });
      }
    });
  }

}
